(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onlydream-spider-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('od-spider-hero')) {
  customElements.define('od-spider-hero', class extends HTMLElement {
    connectedCallback() {
      this.startId = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.started) return;
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas && this.canvas.getContext('2d');
      if (!this.ctx) return;
      this.started = true;
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.paused = this.reduced.matches;
      this.inView = true;
      this.w = this.h = this.last = 0;
      this.spiders = [];
      this.speed = Number(this.dataset.speed) || 1;
      this.size = (Number(this.dataset.size) || 100) / 100;
      this.button = this.querySelector('.odsh__pause');
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, {signal:this.abort.signal});
      this.reduced.addEventListener('change', e => { this.paused=e.matches; this.sync(); }, {signal:this.abort.signal});
      this.mobile.addEventListener('change', () => this.resize(), {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => this.sync(), {signal:this.abort.signal});
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this);
      this.intersectionObserver = new IntersectionObserver(entries => { this.inView=entries[0].isIntersecting; this.sync(); });
      this.intersectionObserver.observe(this);
      this.resize();
      this.sync();
    }
    resize() {
      const r=this.getBoundingClientRect(), ow=this.w, oh=this.h;
      this.w=r.width; this.h=r.height;
      const d=Math.min(devicePixelRatio || 1,2);
      this.canvas.width=Math.round(this.w*d); this.canvas.height=Math.round(this.h*d);
      this.ctx.setTransform(d,0,0,d,0,0);
      if(ow && oh) this.spiders.forEach(s => { s.x*=this.w/ow; s.y*=this.h/oh; });
      const n=Number(this.mobile.matches ? this.dataset.mobileCount : this.dataset.count);
      while(this.spiders.length<n) this.spiders.push({x:Math.random()*this.w,y:Math.random()*this.h,a:Math.random()*Math.PI*2,size:(.65+Math.random()*.55)*this.size,phase:Math.random()*10,turn:0,timer:Math.random()*2,speed:18+Math.random()*24});
      this.spiders.length=n;
      this.draw(); this.sync();
    }
    sync() {
      cancelAnimationFrame(this.frameId); this.frameId=0; this.last=0;
      this.button.hidden=this.spiders.length===0;
      this.button.textContent=this.paused ? '▷' : 'Ⅱ';
      this.button.setAttribute('aria-pressed',String(this.paused));
      this.button.setAttribute('aria-label',this.paused ? 'Riprendi il movimento dei ragni' : 'Metti in pausa i ragni');
      if(!this.paused && this.inView && !document.hidden && this.spiders.length) this.frameId=requestAnimationFrame(t=>this.frame(t));
    }
    frame(t) {
      const dt=this.last ? Math.min((t-this.last)/1000,.04) : 0; this.last=t;
      for(const s of this.spiders) {
        s.timer-=dt;
        if(s.timer<=0) { s.turn=(Math.random()-.5)*1.1; s.timer=1+Math.random()*3; }
        s.a+=s.turn*dt;
        const margin=35*s.size;
        if(s.x<margin || s.x>this.w-margin || s.y<margin || s.y>this.h-margin) {
          const desired=Math.atan2(this.h/2-s.y,this.w/2-s.x)+Math.PI/2;
          const diff=Math.atan2(Math.sin(desired-s.a),Math.cos(desired-s.a));
          s.a+=Math.max(-3*dt,Math.min(3*dt,diff));
        }
        s.x+=Math.sin(s.a)*s.speed*this.speed*dt;
        s.y-=Math.cos(s.a)*s.speed*this.speed*dt;
        s.x=Math.max(-20,Math.min(this.w+20,s.x)); s.y=Math.max(-20,Math.min(this.h+20,s.y));
        s.phase+=dt*s.speed*this.speed*.32;
      }
      this.draw();
      this.frameId=requestAnimationFrame(time=>this.frame(time));
    }
    draw() {
      this.ctx.clearRect(0,0,this.w,this.h);
      this.spiders.forEach(s=>this.drawSpider(s));
    }
    drawSpider(s) {
      const ctx=this.ctx;
      ctx.save(); ctx.translate(s.x,s.y); ctx.rotate(s.a); ctx.scale(s.size,s.size);
      ctx.shadowColor='rgba(0,0,0,.45)'; ctx.shadowBlur=4; ctx.shadowOffsetX=3; ctx.shadowOffsetY=4;
      ctx.strokeStyle='#151510'; ctx.lineCap='round';
      for(const side of [-1,1]) for(let i=0;i<4;i++) {
        const p=s.phase+(i%2)*Math.PI+(side===1?Math.PI:0),swing=Math.sin(p)*3.8,lift=Math.max(0,Math.cos(p))*2;
        ctx.lineWidth=1.65; ctx.beginPath(); ctx.moveTo(side*3,-5+i*3.2);
        ctx.lineTo(side*(13+(i===1||i===2?3:0)),-17+i*10+swing);
        ctx.lineTo(side*(22-lift),-27+i*17+swing); ctx.stroke();
      }
      const grad=ctx.createRadialGradient(-2,5,0,0,6,9);
      grad.addColorStop(0,'#514c3e'); grad.addColorStop(.45,'#29271f'); grad.addColorStop(1,'#0b0d09');
      ctx.fillStyle=grad; ctx.beginPath(); ctx.ellipse(0,6,6.2,9.4,0,0,Math.PI*2); ctx.fill();
      ctx.fillStyle='#20221a'; ctx.beginPath(); ctx.ellipse(0,-5,4.3,5.2,0,0,Math.PI*2); ctx.fill();
      ctx.shadowColor='transparent'; ctx.lineWidth=1;
      for(const side of [-1,1]) { ctx.beginPath(); ctx.moveTo(side*2,-8); ctx.lineTo(side*3,-12); ctx.lineTo(side*1.5,-13); ctx.stroke(); }
      ctx.restore();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startId); cancelAnimationFrame(this.frameId);
      this.resizeObserver?.disconnect(); this.intersectionObserver?.disconnect(); this.abort?.abort();
      this.started=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
